module.exports = __webpack_public_path__ + "img/FR_Mark_WHT.b434cc84.svg";